import { createAction } from '@mews/framework';
import { fetchResources } from '@mews-commander/legacy-entities/src/actions/resources';
import {
    RESOURCES_FETCH,
    SPACE_DIALOG_OPENED,
    SPACE_DIALOG_CLOSED,
    GUESTS_DIALOG_OPENED,
    GUESTS_DIALOG_CLOSED,
    SET_SELECTED_RESERVATION_SERVICE_ID,
} from '../actionTypes';
import { trackReservationModuleEvent } from './tracking';

const SUMMARY_TAB = 'summaryTab';

const fetchResourceSlots =
    ({ scope }: $TSFixMe) =>
    (dispatch: $TSFixMe) => {
        const promise = dispatch(fetchResources({ extent: { slots: true } }));
        return dispatch(createAction(RESOURCES_FETCH, promise, { scope }));
    };

export const initializeSummary =
    ({ scope }: $TSFixMe) =>
    (dispatch: $TSFixMe) =>
        dispatch(fetchResourceSlots({ scope }));

export const openGuestsDialog =
    ({ scope, serviceId }: $TSFixMe) =>
    (dispatch: $TSFixMe) => {
        dispatch(setSelectedReservationServiceId({ scope, serviceId }));
        dispatch(trackReservationModuleEvent({ eventAction: 'guestsDialogOpened', eventLabel: SUMMARY_TAB }));
        dispatch(createAction(GUESTS_DIALOG_OPENED, null, { scope }));
    };

export const closeGuestsDialog = ({ scope }: $TSFixMe) => createAction(GUESTS_DIALOG_CLOSED, null, { scope });
export const openResourceDialog =
    ({ scope, serviceId }: $TSFixMe) =>
    (dispatch: $TSFixMe) => {
        dispatch(setSelectedReservationServiceId({ scope, serviceId }));
        dispatch(trackReservationModuleEvent({ eventAction: 'spacesDialogOpened', eventLabel: SUMMARY_TAB }));
        dispatch(createAction(SPACE_DIALOG_OPENED, null, { scope }));
    };

export const closeSpaceDialog = ({ scope }: $TSFixMe) => createAction(SPACE_DIALOG_CLOSED, null, { scope });

export const trackSummaryPrinted = () => trackReservationModuleEvent({ eventAction: 'summary tab printed' });

export const setSelectedReservationServiceId = ({ scope, serviceId }: $TSFixMe) =>
    createAction(SET_SELECTED_RESERVATION_SERVICE_ID, serviceId, { scope });
